import * as THREE from 'three'
import { disposeO3D } from '../js/threejsHelper';
/**
 * 存放模型的map
 */
let model_map = new Map()


let model_group = null;

let material_box = null;
let material_box_side = null;
/**
 * 加载栏杆等障碍物；
 */
export const load_pnc_constructionAreasList = (vehicleData, threejs_globalScene) => {
    if (!localStorage.getItem('topicChannelChecks')?.includes('/businessResult/pncBusinessInfosList/constructionAreasList')) {
        clearGroupMap(model_map);
        return
    }
    if (!model_group) {
        model_group = new THREE.Group();
        model_group.position.set(0, 0, 0.0008)
        threejs_globalScene.add(model_group);
    }
    let modelDataList = []
    vehicleData.businessResult?.remoteBusinessCommand?.pncBusinessInfosList?.forEach(item => {
        item.constructionAreaList?.constructionAreasList?.forEach(virtualObstacles_item => {
            modelDataList.push(virtualObstacles_item);
        })
    })
    renderBox(modelDataList);
}

export const clear_pnc_constructionAreasList = () => {
    clearGroupMap(model_map);
}

/**
 * 清理模型
 * @param {*} map 
 */
const clearGroupMap = (map) => {
    for (let [key, model] of map) {
        model.visible = false;
        disposeO3D(model)
    }
    map.clear();
}

function renderBox(modeInfolList = []) {
    modeInfolList.forEach(modelInfo => {
        if (!model_map.has(modelInfo.id)) {
            let model3D=createBox(modelInfo)
            model_map.set(modelInfo.id,model3D);
            model_group.add(model3D);
        }
    })
}
function createBox(obstacle) {
    if (!material_box) {
        material_box = new THREE.MeshBasicMaterial({ color: 0xae6642, opacity: 0.2, transparent: true, side: THREE.DoubleSide });
    }
    if (!material_box_side) {
        material_box_side = new THREE.MeshBasicMaterial({ color: 0xf05b72 });
    }
    const shape = new THREE.Shape();
    shape.autoClose = true;
    obstacle.polygon.polygonPointList.forEach((e, index) => {
        if (index == 0) {
            shape.moveTo(e.x, e.y);
        } else {
            shape.lineTo(e.x, e.y);
        }
    });
    let depth = 1;
    const extrudeSettings = {
        depth,
        bevelEnabled: false,
    };
    const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
    const box = new THREE.Mesh(geometry, material_box);
    const edges = new THREE.EdgesGeometry(geometry);
    const box_side = new THREE.LineSegments(edges, material_box_side);
    box.add(box_side);
    return box;
}



